export const dackieColors = {
  launchBtn: '#FFE600',
  black: '#181818',
  hardBlue: '#0c0f24',
  white: '#fff',
  btnShadow: '0px -1px 0px 0px rgba(14, 14, 44, 0.40) inset',
  primary: '#0066FF',
  secondary: '#0CA7FF',
  cardShadow: '0px 0px 60px 0px rgba(0, 0, 0, 0.10)',
}
